import {location, documents, machine, product, troubleshooting, service, auth, customer, warranty, openSession} from './dpmm'

export const dpmmService = {
  fetchDetails: product.fetchDetails,
  fetchMaintenanceSchedule: product.fetchMaintenanceSchedule,
  fetchAvailableRegions: product.fetchAvailableRegions,
  fetchSoftware: product.fetchSoftware,
  fetchFaultCodes: machine.fetchFaultCodes,
  fetchFaultCodesAutocomplete: machine.fetchFaultCodesAutocomplete,
  fetchMachinePassword: machine.fetchMachinePassword,
  updateMachinePassword: machine.updateMachinePassword,
  fetchMachineData: machine.fetchMachineData,
  fetchMachineHistory: machine.fetchMachineHistory,
  fetchControllers: machine.fetchControllers,
  fetchWarrantyInclusions: machine.fetchWarrantyInclusions,
  fetchLocationHistory: location.fetchLocationHistory,
  fetchLastKnownLocation: location.fetchLastKnownLocation,
  troubleshootingSessionStart: troubleshooting.troubleshootingSessionStart,
  troubleshootingSessionResume: troubleshooting.troubleshootingSessionResume,
  fetchTroubleshootingGuides: troubleshooting.fetchTroubleshootingGuides,
  fetchTroubleshootingTopGuides: troubleshooting.fetchTroubleshootingTopGuides,
  fetchTroubleshootingSessionList: troubleshooting.fetchTroubleshootingSessionList,
  fetchTroubleshootingSettings: troubleshooting.fetchTroubleshootingSettings,
  troubleshootingSessionSummary: troubleshooting.troubleshootingSessionSummary,
  troubleshootingSessionSummaryPDF: troubleshooting.troubleshootingSessionSummaryPDF,
  fetchFaultCodesDetails: troubleshooting.fetchFaultCodesDetails,
  fetchBulletins: documents.fetchBulletins,
  fetchManuals: documents.fetchManuals,
  fetchDocumentDownloadLink: documents.fetchDocumentDownloadLink,
  fetchServiceLetters: documents.fetchServiceLetters,
  fetchSchematics: documents.fetchSchematics,
  fetchSchematicDetails: documents.fetchSchematicDetails,
  sendNewGuideForm: service.sendNewGuideForm,
  fetchFieldMods: service.fetchFieldMods,
  getWarrantyPlans: service.getWarrantyPlans,
  getBuiltOptions: service.getBuiltOptions,
  fetchIdentity: auth.fetchIdentity,
  fetchOrgDescendants: auth.fetchOrgDescendants,
  searchByCustomer: customer.searchByCustomer,
  searchByMdmId: customer.searchByMdmId,
  sessionsStats: openSession.sessionsStats,
  orgSessionsStats: openSession.orgSessionsStats,
  sessionsList: openSession.sessionsList,
  fetchWarranyArticles: warranty.fetchWarranyArticles
}
